import React from 'react';

import { Progress } from '@/components/ui/progressbar';

interface FreeShippingEarnedProps {
    freeShippingThresholdNumber: number;
    delayedPercentage: number;
    isRogersCCFreeShipApplied?: boolean;
    autoFreeShipAwayFromThresholdAmount?: number;
    isAutoFreeShipApplied?: boolean;
    cart: any;
}

const FreeShippingEarned: React.FC<FreeShippingEarnedProps> = ({
    freeShippingThresholdNumber,
    delayedPercentage: delayedPercentage,
    isRogersCCFreeShipApplied,
    autoFreeShipAwayFromThresholdAmount,
    isAutoFreeShipApplied,
    cart,
}) => {
    const showProgressBar =
        (isAutoFreeShipApplied || autoFreeShipAwayFromThresholdAmount > 0) && freeShippingThresholdNumber > 0;
    const showEarnedMessage = isAutoFreeShipApplied || isRogersCCFreeShipApplied;
    const showThresholdDistance = autoFreeShipAwayFromThresholdAmount > 0;
    const HideProgressBar = () => <div className="h-11">&nbsp;</div>;

    return (
        <>
            {showEarnedMessage || showThresholdDistance ? (
                <>
                    {showThresholdDistance ? (
                        <div className="flex h-7 items-center justify-center text-center text-[.61rem] xxsm:text-xs">
                            <div>
                                You&apos;re <b>{cart?.OrderSummary?.AutoFreeShipAwayFromThreshold}</b> from{' '}
                                <b>
                                    FREE standard shipping on{' '}
                                    <a
                                        href="/pages/customer-service/shipping-handling"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="whitespace-nowrap !underline"
                                    >
                                        eligible items
                                    </a>
                                </b>
                            </div>
                        </div>
                    ) : (
                        <>
                            {isRogersCCFreeShipApplied ? (
                                <div className="mb-2.5 mt-2.5 h-9 text-center text-xs leading-4">
                                    You&apos;ve earned <b>FREE standard shipping</b> with{' '}
                                    <b className="whitespace-nowrap">Rogers Bank Mastercard!</b>
                                </div>
                            ) : (
                                <div className="mt-2.5 h-5 text-center text-xs leading-5">
                                    You&apos;ve earned <b>FREE standard shipping!</b>
                                </div>
                            )}
                        </>
                    )}
                    {showProgressBar && (
                        <div className="mb-2.5 grid h-9 grid-cols-[auto_1fr_auto] gap-2">
                            <div className="flex items-center justify-center">$0</div>
                            <div className="flex items-center justify-center">
                                <Progress value={delayedPercentage} />
                            </div>
                            <div className="flex items-center justify-center">${freeShippingThresholdNumber}</div>
                        </div>
                    )}
                    {!showProgressBar && showEarnedMessage && !isRogersCCFreeShipApplied && (
                        <div className="mb-2.5 grid h-9 grid-cols-[auto_1fr_auto] gap-2"></div>
                    )}
                </>
            ) : (
                <HideProgressBar />
            )}
        </>
    );
};

export default FreeShippingEarned;
